export default __webpack_public_path__ + "static/media/Stalker's Tunic of the Grim Cabal.9a6bb69e.jpg";